<template>
    <div class="flex flex-col justify-center uppercase items-center w-full text-secondary text-xl poppins-bold">
        <div class="loader"></div>
        <div v-if="showText" class="mt-2">Loading{{dots}}</div>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            showText: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            dots: ''
        }),
        methods: {
            startLoading() {
                setInterval(() => {
                    if(this.dots.length < 3) {
                        this.dots += '.';
                    } else {
                        this.dots = '';
                    }
                }, 500)
            },
        },
        mounted() {
            this.startLoading();
        }
    }
</script>

<style scoped>
    .loader {
        border: 4px solid white; /* Light grey */
        border-top: 4px solid #0174EA; /* Blue */
        border-radius: 50%;
        width: 32px;
        height: 32px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>